import { Button } from "@/components/ui/button"
import getPharmacyID from "@/utils/pharmacy_code"
import React, { useEffect } from "react"
import { Route as indexRoute } from "../index"
import { authStore } from "@/providers/authStore"
import { PharmacyCodeList } from "./modal"


const Component = () => {
  const [count, setCount] = React.useState(0);
  const data = indexRoute.useLoaderData() as PharmacyCodeList;
  console.log(authStore.getUser());

  const handlePharmacySelection = (pharmacy_code: string) => {
    localStorage.setItem('pharmacy_id', pharmacy_code);
    window.location.href = '/overview';
  };

  return (
    <div className="grid place-items-center">
      <div className="border-[0.5px] border-gray-200 rounded-md text-center px-24 py-12">
        <p className="font-semibold text-xl">Hi, {authStore.getUser()?.first_name}!</p>
        <p className="text-sm text-gray-600">Select your branch to proceed</p>
        <hr className="my-6" />

            <>
              <p className="text-sm text-gray-600 mb-4">Select from the options below</p>
              <div className="flex flex-col space-y-2">
                {data.map((pharmacy_id, i) => (
                    <Button
                      key={i}
                      variant={'outline'}
                      size={'sm'}
                      onClick={() => handlePharmacySelection(pharmacy_id.pharmacy_code)}
                    >{pharmacy_id.pharmacy_name}</Button>
                  )
                )}
              </div>
            </>
      </div>
      {/* <h1>Select Pharmacy</h1>
      <Button onClick={() => {
        setCount(count + 1);
      }}>Get Pharmacies</Button>
      <Button
        onClick={() => {
          kc.logout()
        }}
      >Logout</Button>
      <br />
      {data.map((pharmacy_id) => (
        <Button
          onClick={() => {
            Cookie.set('pharmacy_id', pharmacy_id);
            router.navigate({
              to: '/overview',
              replace: true,
            })
          }}
        >{pharmacy_id}</Button>
      )
      )} */}
    </div>
  )
}

export default Component